import { DataBean } from "../DataBean";


export class DOCMetadataDefinition extends DataBean {

    public async getDOCMetadataDefinition(iddocmetadatadefinition: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCMetadataDefinition_getDOCMetadataDefinition_Number", [iddocmetadatadefinition]);
    }

    public async getDOCMetadataDefinitionCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCMetadataDefinitionCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCMetadataDefinition(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCMetadataDefinition_updateDOCMetadataDefinition_com.advantage.forms.bean.DOCMetadataDefinition", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCMetadataDefinition"
            }
        ]);
    }

}